const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChatCenteredDots(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M11.9453 15.3672L10.7891 17.2969C10.7324 17.389 10.6532 17.465 10.5588 17.5178C10.4644 17.5705 10.3581 17.5982 10.25 17.5982C10.1419 17.5982 10.0356 17.5705 9.94121 17.5178C9.84684 17.465 9.76756 17.389 9.71094 17.2969L8.55469 15.3672C8.5003 15.2746 8.42269 15.1977 8.32952 15.1443C8.23635 15.0909 8.13084 15.0627 8.02344 15.0625H3.375C3.20924 15.0625 3.05027 14.9967 2.93306 14.8794C2.81585 14.7622 2.75 14.6033 2.75 14.4375V4.4375C2.75 4.27174 2.81585 4.11277 2.93306 3.99556C3.05027 3.87835 3.20924 3.8125 3.375 3.8125H17.125C17.2908 3.8125 17.4497 3.87835 17.5669 3.99556C17.6842 4.11277 17.75 4.27174 17.75 4.4375V14.4375C17.75 14.6033 17.6842 14.7622 17.5669 14.8794C17.4497 14.9967 17.2908 15.0625 17.125 15.0625H12.4766C12.3692 15.0627 12.2637 15.0909 12.1705 15.1443C12.0773 15.1977 11.9997 15.2746 11.9453 15.3672Z",
    fill: "white",
    stroke: "#5A045A",
    style: {
      fill: "white",
      fillOpacity: 1,
      stroke: "#5A045A",
      stroke: "color(display-p3 0.3529 0.0157 0.3529)",
      strokeOpacity: 1
    },
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.25 10.375C10.7678 10.375 11.1875 9.95527 11.1875 9.4375C11.1875 8.91973 10.7678 8.5 10.25 8.5C9.73223 8.5 9.3125 8.91973 9.3125 9.4375C9.3125 9.95527 9.73223 10.375 10.25 10.375Z",
    fill: "#5A045A",
    style: {
      fill: "#5A045A",
      fill: "color(display-p3 0.3529 0.0157 0.3529)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.5 10.375C7.01777 10.375 7.4375 9.95527 7.4375 9.4375C7.4375 8.91973 7.01777 8.5 6.5 8.5C5.98223 8.5 5.5625 8.91973 5.5625 9.4375C5.5625 9.95527 5.98223 10.375 6.5 10.375Z",
    fill: "#5A045A",
    style: {
      fill: "#5A045A",
      fill: "color(display-p3 0.3529 0.0157 0.3529)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 10.375C14.5178 10.375 14.9375 9.95527 14.9375 9.4375C14.9375 8.91973 14.5178 8.5 14 8.5C13.4822 8.5 13.0625 8.91973 13.0625 9.4375C13.0625 9.95527 13.4822 10.375 14 10.375Z",
    fill: "#5A045A",
    style: {
      fill: "#5A045A",
      fill: "color(display-p3 0.3529 0.0157 0.3529)",
      fillOpacity: 1
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatCenteredDots);
export default __webpack_public_path__ + "static/media/ChatCenteredDots.c659ed41ae05d2968f89a693fcde8397.svg";
export { ForwardRef as ReactComponent };